import List from './List/List';
import Cards from './Cards/Cards';
import Grouped from './Grouped/Grouped';
import Compact from './Compact/Compact';
import Columns from './Columns/Columns';
import Banner from './Banner/Banner';

const templates = {
  List,
  Cards,
  Grouped,
  Compact,
  Columns,
  Banner,
};

export default templates;